import React, { useState } from 'react';
import { AppDrawer } from '../ui/AppDrawer';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Loader2, XCircle } from 'lucide-react';

export const DenyReasonModal = ({ 
  open, 
  onClose,
  onConfirm,
  title = 'Deny Request',
  description = 'Please provide a reason for denying this request (optional).',
  isLoading = false,
}) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    onConfirm(reason || null);
    setReason('');
  };

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <AppDrawer
      open={open}
      onOpenChange={(nextOpen) => { if (!nextOpen) handleClose(); }}
      title={
        <span className="flex items-center gap-2 text-destructive">
          <XCircle className="w-5 h-5" />
          {title}
        </span>
      }
      description={description}
      size="md"
      isDirty={reason.length > 0}
      data-testid="deny-reason-drawer"
      footer={
        <>
          <Button variant="outline" onClick={handleClose} disabled={isLoading} data-testid="deny-cancel-btn">
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleConfirm} disabled={isLoading} data-testid="deny-confirm-btn">
            {isLoading ? (
              <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Denying...</>
            ) : (
              'Deny Request'
            )}
          </Button>
        </>
      }
    >
      <div className="space-y-2">
        <Label className="text-sm font-bold uppercase tracking-wide">Denial Reason (optional)</Label>
        <Textarea
          placeholder="Enter reason for denial..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          className="resize-none"
          data-testid="deny-reason-input"
        />
      </div>
    </AppDrawer>
  );
};
